<template lang="html">
  <div class="wcc fields">
    <FieldsSection :boundData="calculatorData.price">
      <Field label="Price" :boundData="calculatorData.price"></Field>
    </FieldsSection>
    <FieldsSection :boundData="calculatorData.listingGrossCommissions">
      <h2 class="wcc section-label">Listing Gross Commissions</h2>
      <CommissionField :commissionData="calculatorData.listingGrossCommissions" :updateDefaults="calculatorData.updateDefaults" :agent="'listing'"></CommissionField>
    </FieldsSection>
    <FieldsSection :boundData="calculatorData.buyingAgentCommission">
      <h2 class="wcc section-label">Buying Agent Commission</h2>
      <CommissionField :commissionData="calculatorData.buyingAgentCommission" :updateDefaults="calculatorData.updateDefaults" :agent="'buying'"></CommissionField>
    </FieldsSection>   
    <FieldsSection :boundData="calculatorData.salesTaxRate">
      <Field label="GST Tax Rate" :boundData="calculatorData.salesTaxRate"></Field>
    </FieldsSection>    
  </div>
</template>
<script>
  import CommissionField from './CommissionField.vue'
  import FieldsSection from './FieldsSection.vue'
  import Field from './Field.vue'
  export default {
    props: ['calculatorData'],
    data() {
      return {
        active: ''
      }
    },
    components: {
      CommissionField,
      FieldsSection,
      Field
    }
  }
</script>
<style lang="scss">
</style>